import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import TripaySettings from '../components/TripaySettings';
import PaybosSettings from '../components/PaybosSettings';

const SettingsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tab = location.pathname.includes('paybos') ? 1 : 0;
  const [activeTab, setActiveTab] = useState(tab);

  const handleTabChange = (_: React.SyntheticEvent, value: number) => {
    setActiveTab(value);
    navigate(value === 0 ? '/settings/tripay' : '/settings/paybos');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Payment Gateway
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Konfigurasi gateway pembayaran online untuk tagihan pelanggan
        </Typography>
      </Box>

      <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab label="Tripay" />
        <Tab label="PayBOS (QRIS)" />
      </Tabs>

      {activeTab === 0 && <TripaySettings />}
      {activeTab === 1 && <PaybosSettings />}
    </Container>
  );
};

export default SettingsPage;
